import * as API from '../_api';
import * as Sentry from '@sentry/vue';

// @ts-ignore
export const create = async ({ commit, dispatch }, advisor) => {
  try {
    await API.create(advisor);
    return true;
  } catch (ex: any) {
    Sentry.captureException(ex);
    dispatch('common/snackbar/error', ex, { root: true });
    return false;
  }
};

// @ts-ignore
export const read = async ({ commit, dispatch }) => {
  try {
    const all = await API.read();
    commit('setAll', all);
    return true;
  } catch (ex: any) {
    Sentry.captureException(ex);
    dispatch('common/snackbar/error', 'Fatal Error. Please try again later', { root: true });
    return false;
  }
};

// @ts-ignore
export const update = async ({ commit, dispatch }, advisor) => {
  try {
    await API.update(advisor);
    return true;
  } catch (ex: any) {
    Sentry.captureException(ex);
    dispatch('common/snackbar/error', 'Fatal Error. Please try again later', { root: true });
    return false;
  }
};

// @ts-ignore
export const remove = async ({ commit, dispatch }, { username }) => {
  try {
    await API.del({ username });
    return true;
  } catch (ex: any) {
    Sentry.captureException(ex);
    dispatch('common/snackbar/error', 'Fatal Error. Please try again later', { root: true });
    return false;
  }
};
